import { Badge, Drawer, Tabs, Row, Col, Image } from 'antd'

import { DoubleRightOutlined } from '@ant-design/icons'

import { useEffect, useState } from 'react'
import moment from 'moment'

import './TaskDrawer.style.less'
import UpdatePlanDateForm from './UpdatePlanDateForm'
import AssigneeForm from './AssigneeForm'
import StatusActualDateForm from './StatusActualDateForm'

import {
  useOrderCollaborator,
  useTaskActivities,
  useTaskDocumentCount,
} from '../TaskTable.hook'
import History from './History'
import { DocumentField } from './DocumentField/DocumentField'
import CommentTab from './CommentTab/CommentTab'
import { DATE_FORMAT } from '@/constant/date'

function TaskDrawer(props: any) {
  const { item, refetch, onClick, selectedTask, onCancel } = props
  const { orderImageUrl, orderNo, taskName, sectionName, supplier, id } = item
  const { planDate, assignee, actualDate, value, type, isRangeDate } = item
  const [currentTab, setCurrentTab] = useState('detail')
  const { plan_start_date, order, actual_date } = item
  const [detailData, setDetailData] = useState({
    value,
    progress_status: item.progress_status,
  })

  const payloadTask = {
    id: id,
    enabled: selectedTask === id,
  }
  const { data: history, refetch: refetchHistory } =
    useTaskActivities(payloadTask)
  const { data: collaborators } = useOrderCollaborator({
    id: order?.id,
    enabled: selectedTask === id,
  })

  const { data: taskDocumentCount, refetch: refetchTaskDocumentCount } =
    useTaskDocumentCount(payloadTask)

  const showDrawer = () => {
    onClick(id)
  }

  const onClose = () => {
    refetch()
    onCancel()
  }

  function oderDetail() {
    return (
      <Row align="middle" justify={'space-between'}>
        <Col span={18}>
          <span>
            <span className="sub-label">{sectionName}</span>
            <br />
            <span className="order-no">
              <b>{taskName}</b>
            </span>
            <br />
            <span className="sub-label">{orderNo}</span>
            <br />
            <span className="sub-label-light">{supplier}</span>
          </span>
        </Col>
        <Col>
          <Image
            className="order-image-detail"
            width={94}
            height={94}
            preview={false}
            src={orderImageUrl}
          />
        </Col>
      </Row>
    )
  }

  function detailTab() {
    const onUpdated = (value) => {
      try {
        setDetailData({
          value:
            value.tasks.type === 'percentage_progress_type'
              ? '0'
              : value.tasks.value,
          progress_status: value.tasks.progress_status,
        })
      } catch (error) {}
    }
    return (
      <>
        <UpdatePlanDateForm
          id={item.id}
          planDate={planDate}
          isRangeDate={isRangeDate}
          refetch={refetchHistory}
          onUpdated={onUpdated}
          canEdit={history?.data?.can_write}
          data={item}
        />
        <AssigneeForm
          id={item.id}
          collaborators={collaborators}
          assignee={assignee}
          refetch={refetchHistory}
          onUpdated={onUpdated}
          canEdit={history?.data?.can_write}
          data={item}
        />
        <StatusActualDateForm
          id={item.id}
          taskType={type}
          status={history?.data?.value || detailData.value}
          plan_start_date={plan_start_date}
          actualDate={history?.data?.actual_date || actual_date}
          progress_status={history?.data?.progress_status}
          refetch={refetchHistory}
          data={item}
          onUpdated={onUpdated}
          canEdit={history?.data?.can_write}
        />
        <History history={history?.data?.activities} />
      </>
    )
  }

  function documentTab() {
    return <DocumentField onUpdated={refetchTaskDocumentCount} taskId={id} />
  }

  return (
    <>
      <a className="taskLink" onClick={showDrawer}>
        {item.taskName}
      </a>
      <Drawer
        title=""
        closeIcon={<DoubleRightOutlined />}
        placement="right"
        onClose={onClose}
        open={selectedTask === id}
        width={550}
        mask={false}
      >
        <div className={'detail ' + type}>
          {oderDetail()}
          <Tabs defaultActiveKey="1" onChange={setCurrentTab}>
            <Tabs.TabPane tab="Details" key="1">
              {detailTab()}
            </Tabs.TabPane>

            <Tabs.TabPane
              key="2"
              tab={
                <span>
                  {'Comments '}
                  {taskDocumentCount?.data?.comment_counts > 0 && (
                    <Badge
                      style={{ borderRadius: 3 }}
                      color={currentTab === '2' ? '#ef9747' : 'gray'}
                      count={taskDocumentCount?.data?.comment_counts}
                    />
                  )}
                </span>
              }
            >
              <CommentTab task={item} open={!!selectedTask} />
            </Tabs.TabPane>

            <Tabs.TabPane
              tab={
                <span>
                  {'Documents '}
                  {taskDocumentCount?.data?.document_counts > 0 && (
                    <Badge
                      style={{ borderRadius: 3 }}
                      color={currentTab === '3' ? '#ef9747' : 'gray'}
                      count={taskDocumentCount?.data?.document_counts}
                    />
                  )}
                </span>
              }
              key="3"
            >
              {documentTab()}
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Drawer>
    </>
  )
}

export default TaskDrawer
